import { documentOriginSchema, type DocumentOrigin } from '@shared/schemas/document';

export type DocumentsOriginFilter = 'all' | DocumentOrigin;

export type DocumentsListParams = {
  origin: DocumentsOriginFilter;
  page: number;
  search: string;
};

const SEARCH_PARAM = 'q';
const ORIGIN_PARAM = 'origin';
const PAGE_PARAM = 'page';

/** Lenient on purpose: a hand-edited or stale URL falls back to the defaults instead of failing. */
export function parseDocumentsListParams(params: URLSearchParams): DocumentsListParams {
  const origin = documentOriginSchema.safeParse(params.get(ORIGIN_PARAM));
  const page = Number.parseInt(params.get(PAGE_PARAM) ?? '', 10);

  return {
    origin: origin.success ? origin.data : 'all',
    page: Number.isSafeInteger(page) && page > 1 ? page : 1,
    search: params.get(SEARCH_PARAM) ?? '',
  };
}

/** Defaults are omitted so the plain `/documents` URL stays the canonical first page. */
export function buildDocumentsListSearchParams(input: DocumentsListParams) {
  const params = new URLSearchParams();
  if (input.search) {
    params.set(SEARCH_PARAM, input.search);
  }
  if (input.origin !== 'all') {
    params.set(ORIGIN_PARAM, input.origin);
  }
  if (input.page > 1) {
    params.set(PAGE_PARAM, String(input.page));
  }
  return params;
}
